import React from 'react'
import TopHeader from './TopHeader/TopHeader'
import './Header.css'
import BottemHeader from './BottemHeader/BottemHeader'

function Header() {
  return (
    <div className="header-container">
        <TopHeader/>
        <BottemHeader/>
    </div>
  )
}

export default Header
